import React from 'react'
import decoLinesContactPM from '#app/assets/images/decorative/deco-lines-contact-pm.svg'
import logoAsociacionValorTres from '#app/assets/images/logos/asociacion-valor-tres-color-logo.svg'
import { Button } from '#app/components/ui/button.tsx'
import { Icon } from '#app/components/ui/icon.tsx'
import { InputText } from '#app/components/ui/input-text.tsx'
import { Tag } from '#app/components/ui/tag.tsx'

interface JoinEffortsSectionProps {
	title?: string
	subtitle?: string
	tagText?: string
}

export function JoinEffortsSection({
	title,
	subtitle,
	tagText,
}: JoinEffortsSectionProps) {
	return (
		<section className="relative overflow-hidden bg-green-50 py-[64px] md:py-[178px]">
			{/* Decorative background elements container */}
			<div className="absolute inset-0 overflow-hidden">
				{/* Decorative background lines pattern */}
				<div className="absolute top-[-249px] left-[380px] h-[1340.65px]">
					<img
						src={decoLinesContactPM}
						alt=""
						className="h-full w-full object-contain"
						aria-hidden="true"
					/>
				</div>

				{/* Decorative background gradients */}
				<div className="absolute top-[146px] left-[-108px] h-[505.56px] w-[1957.39px] rotate-[328.954deg]">
					<div className="bg-gradient-radial-cyan h-full w-full" />
				</div>
				<div className="absolute top-[-29px] left-[-800px] h-[505.56px] w-[1259.35px] rotate-[328.954deg]">
					<div className="bg-gradient-radial-cyan h-full w-full" />
				</div>
			</div>

			{/* Content Container */}
			<div className="relative mx-auto flex max-w-[1200px] flex-col items-start gap-[40px] px-[37.5px] md:flex-row md:px-0">
				{/* Left Column - Text Content */}
				<div className="flex flex-1 flex-col gap-[40px]">
					{/* Tag */}
					<div className="inline-flex">
						<Tag
							size="l"
							corner="rounded"
							variant="primary"
							color="green"
							appearance="solid"
							option="text-icon-left"
							leftIcon="envelope-closed"
						>
							{tagText || 'Contacto'}
						</Tag>
					</div>

					{/* Title and Description */}
					<div className="flex flex-col gap-[24px]">
						<h2 className="text-[32px] leading-[45px] font-medium text-blue-900 md:text-[56px] md:leading-[70px]">
							{title || 'Sumá esfuerzos para un cambio real'}
						</h2>
						<p className="text-[18px] leading-[30px] font-normal text-blue-900">
							{subtitle ||
								'Completá con tus datos personales y nos pondremos en contacto.'}
						</p>
					</div>

					{/* Logo */}
					<div className="h-[128px] w-[230px]">
						<img
							src={logoAsociacionValorTres}
							alt="Asociación Valor Tres"
							className="h-full w-full object-contain"
						/>
					</div>
				</div>

				{/* Right Column - Form */}
				<div className="w-full rounded-[24px] bg-white p-[24px] md:w-[424px] md:p-[32px]">
					<form method="post" className="flex flex-col items-end gap-[16px]">
						{/* Form Fields Container - Nombre y Apellido con gap de 16px */}
						<div className="flex w-full flex-col gap-[16px]">
							{/* Nombre */}
							<InputText
								labelPosition="internal"
								name="name"
								label="Nombre"
								required
								className="h-[40px] w-full"
							/>

							{/* Apellido */}
							<InputText
								labelPosition="internal"
								name="lastname"
								label="Apellido"
								required
								className="h-[40px] w-full"
							/>
						</div>

						{/* Form Fields Container - Teléfono y Email con gap de 16px */}
						<div className="flex w-full flex-col gap-[16px]">
							{/* Teléfono */}
							<InputText
								labelPosition="internal"
								name="phone"
								label="Teléfono"
								required
								className="h-[40px] w-full"
							/>

							{/* Email */}
							<InputText
								labelPosition="internal"
								name="email"
								label="Email"
								type="email"
								required
								className="h-[40px] w-full"
							/>
						</div>

						{/* Submit Button */}
						<Button
							type="submit"
							variant="primary"
							size="l"
							rightIcon={<Icon name="arrow-right" size="sm" />}
							className="rounded-[12px] bg-green-500 px-[24px] py-[16px] hover:bg-green-600"
						>
							Enviar
						</Button>
					</form>
				</div>
			</div>
		</section>
	)
}
